function isDpoActiveOnPage() {
  try {
    return typeof window.dpoEvent !== "undefined";
  } catch (e) {
    return false;
  }
}

function hasDpoOptions() {
  return document.body.classList.contains("has_dpo_options");
}

function getDpoContainer() {
  return document.querySelector(".dpo-container") || null;
}

function waitForDpo(callback) {
  if (window.dpoObserver != null && window.dpoElement != null) {
    callback();
    return;
  }

  if (!window._dpoWaitQueue) {
    window._dpoWaitQueue = [];

    let _dpoObserver;
    let _dpoElement;

    const tryApply = () => {
      if (!_dpoObserver || !_dpoElement) return;
      const queue = window._dpoWaitQueue.splice(0);
      queue.forEach((fn) => fn());
    };

    if (window.dpoObserver != null) {
      _dpoObserver = window.dpoObserver;
    } else {
      Object.defineProperty(window, "dpoObserver", {
        configurable: true,
        get() {
          return _dpoObserver;
        },
        set(val) {
          _dpoObserver = val;
          Object.defineProperty(window, "dpoObserver", {
            configurable: true,
            writable: true,
            value: val,
          });
          tryApply();
        },
      });
    }

    if (window.dpoElement != null) {
      _dpoElement = window.dpoElement;
      tryApply();
    } else {
      Object.defineProperty(window, "dpoElement", {
        configurable: true,
        get() {
          return _dpoElement;
        },
        set(val) {
          _dpoElement = val;
          Object.defineProperty(window, "dpoElement", {
            configurable: true,
            writable: true,
            value: val,
          });
          tryApply();
        },
      });
    }
  }

  window._dpoWaitQueue.push(callback);
}
